import React from 'react';
import { bool, func, number, shape } from 'prop-types';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';

// Icons
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { Typography } from '@mui/material';

const FilterCounter = theme => ({
  alignItems: 'center',
  backgroundColor: theme.palette.primary.light,
  borderRadius: 2,
  color: theme.palette.primary.main,
  display: 'flex',
  fontSize: 12,
  height: 16,
  justifyContent: 'center',
  marginLeft: theme.spacing(1),
  padding: 2,
  width: 14,
});

const CardsPanelHeader = ({
  filtersOpen,
  filtersRef,
  filterIdentifierCount,
  pending,
  setFiltersOpen,
}) => {
  const theme = useTheme();
  return (
    <Button
      disabled={pending}
      onClick={() => setFiltersOpen(!filtersOpen)}
      onClose={() => setFiltersOpen(false)}
      ref={filtersRef}
      sx={{ alignSelf: 'end', ml: 2 }}
      variant="text"
    >
      Filters
      {filterIdentifierCount >= 1 && (
        <Typography sx={{ ...FilterCounter(theme) }}>{filterIdentifierCount}</Typography>
      )}
      {filtersOpen ? (
        <ExpandLessRoundedIcon position="right" variant="buttonsChild" />
      ) : (
        <ExpandMoreRoundedIcon position="right" variant="buttonsChild" />
      )}
    </Button>
  );
};

CardsPanelHeader.propTypes = {
  filterIdentifierCount: number.isRequired,
  filtersOpen: bool.isRequired,
  filtersRef: shape({}).isRequired,
  pending: bool.isRequired,
  setFiltersOpen: func.isRequired,
};

export default CardsPanelHeader;
